export default __webpack_public_path__ + "static/media/s4_title-spring.0c2f7028.png";